<div class="cookie-consent" *ngIf="visible" role="dialog" aria-live="polite"
     aria-label="Cookie consent">
  <p class="cookie-consent__text">
    We use analytics cookies to understand how Rap Almanac is used. Nothing is
    loaded until you choose. Read our
    <a routerLink="/privacy-notice" class="cookie-consent__link">Privacy Policy</a>.
  </p>
  <div class="cookie-consent__actions">
    <button type="button" class="cookie-consent__btn cookie-consent__btn--decline"
            (click)="decline()">Decline</button>
    <button type="button" class="cookie-consent__btn cookie-consent__btn--accept"
            (click)="accept()">Accept</button>
  </div>
</div>
